import { useAppDispatch, useAppSelector } from "../../ReduxToolkit/Hooks";
import { setColorPicker } from "../../ReduxToolkit/Reducers/TemplateCustomizerReducers";

const ColorChoose = () => {
  const dispatch = useAppDispatch();
  const { colorPicker } = useAppSelector((state) => state.templateCustomizer);

  return (
    <div className="color-picker">
      <h5>{"Choose color"}</h5>
      <ul className="colors">
        {colorPicker.map((item, index) => (
          <li className={`${item.class} ${item.active ? "active" : ""}`} onClick={() => dispatch(setColorPicker(item.color))} key={index} />
        ))}
      </ul>
    </div>
  );
};

export default ColorChoose;
